var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-background",attrs:{"id":"app","oncontextmenu":"return false","ondragstart":"return false"}},[_c('router-view'),(_vm.isShowFull)?_c('LFullScreen'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }